import LocalMemory from './local-memory';

export { LocalMemory };

export default LocalMemory;
